/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_PostInputs */

const vi_media_owner_post = /** @type {(inputs: Media_Owner_PostInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bài viết`)
};

/**

* @param {Media_Owner_PostInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_post = /** @type {((inputs?: Media_Owner_PostInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_PostInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_post(inputs)
});